export const BATCH_REQUEST_SIZE = 100;

export const LOAD_ERROR_MESSAGE =
	'An error occured when trying to load "No Readings" results.';

export default {
	BATCH_REQUEST_SIZE,
	LOAD_ERROR_MESSAGE
};
